/*! De La Terre — PDP Runtime Loader v2.0 | P1.9.1
    Defere ro-custom.js para idle/intencao e carrega o zoom customizado somente sob demanda. */
(() => {
  'use strict';

  if (window.__dltPdpRuntimeLoaderV2) return;
  window.__dltPdpRuntimeLoaderV2 = true;

  const currentScript = document.currentScript;
  const runtimeUrl = currentScript?.dataset.dltPdpRuntimeJs || '';
  const zoomJsUrl = currentScript?.dataset.dltPdpZoomJs || '';
  const zoomCssUrl = currentScript?.dataset.dltPdpZoomCss || '';

  const PDP_SCOPE = '.shopify-section--main-product, [data-dlt-pdp-sticky-cta], [data-dlt-pdp-back]';
  const ZOOM_BUTTON = 'button[is="product-zoom-button"]';
  const ZOOM_GALLERY = 'product-gallery[allow-zoom]';

  let runtimePromise = null;
  let zoomPromise = null;
  let idleHandle = 0;
  let fallbackTimer = 0;
  let runtimeLoaded = false;
  let zoomLoaded = Boolean(window.DLTProductZoom || window.__dltZoomModalV4);

  const existingScriptPromise = (url) => {
    if (!url) return null;
    const scripts = Array.from(document.scripts);
    const existing = scripts.find((script) => script.src === url);
    if (!existing) return null;
    if (existing.dataset.dltLoaded === 'true') return Promise.resolve(existing);
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve(existing), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Falha ao carregar ${url}`)), { once: true });
    });
  };

  const loadScript = (url, { module = false } = {}) => {
    if (!url) return Promise.reject(new Error('URL de script ausente.'));
    const existing = existingScriptPromise(url);
    if (existing) return existing;

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      if (module) script.type = 'module';
      script.dataset.dltDeferred = 'true';
      script.addEventListener('load', () => {
        script.dataset.dltLoaded = 'true';
        resolve(script);
      }, { once: true });
      script.addEventListener('error', () => reject(new Error(`Falha ao carregar ${url}`)), { once: true });
      document.head.appendChild(script);
    });
  };

  const loadStylesheet = (url) => {
    if (!url) return Promise.reject(new Error('URL de stylesheet ausente.'));
    const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
    const existing = links.find((link) => link.href === url);
    if (existing) {
      if (existing.sheet) return Promise.resolve(existing);
      return new Promise((resolve, reject) => {
        existing.addEventListener('load', () => resolve(existing), { once: true });
        existing.addEventListener('error', () => reject(new Error(`Falha ao carregar ${url}`)), { once: true });
      });
    }

    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.dltDeferred = 'true';
      link.addEventListener('load', () => resolve(link), { once: true });
      link.addEventListener('error', () => reject(new Error(`Falha ao carregar ${url}`)), { once: true });
      document.head.appendChild(link);
    });
  };

  const cancelRuntimeIdle = () => {
    if (idleHandle && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(idleHandle);
    }
    idleHandle = 0;
    if (fallbackTimer) window.clearTimeout(fallbackTimer);
    fallbackTimer = 0;
  };

  const loadRuntime = () => {
    if (runtimeLoaded) return Promise.resolve();
    if (runtimePromise) return runtimePromise;
    cancelRuntimeIdle();

    window.__dltPdpRuntimeDeferredBoot = true;
    runtimePromise = loadScript(runtimeUrl, { module: true })
      .then(() => {
        runtimeLoaded = true;
        document.documentElement.dataset.dltPdpRuntime = 'ready';
      })
      .catch((error) => {
        runtimePromise = null;
        console.error('[DLT PDP] Falha ao carregar runtime complementar.', error);
        throw error;
      });

    return runtimePromise;
  };

  const scheduleRuntime = () => {
    if (runtimeLoaded || runtimePromise || !runtimeUrl) return;

    const schedule = () => {
      if (runtimeLoaded || runtimePromise) return;
      if ('requestIdleCallback' in window) {
        idleHandle = window.requestIdleCallback(() => {
          idleHandle = 0;
          loadRuntime().catch(() => {});
        }, { timeout: 950 });
      } else {
        fallbackTimer = window.setTimeout(() => {
          fallbackTimer = 0;
          loadRuntime().catch(() => {});
        }, 280);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }
  };

  const prewarmRuntimeFromEvent = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest(PDP_SCOPE)) return;
    loadRuntime().catch(() => {});
  };

  const getZoomApi = () => window.DLTProductZoom || null;

  const loadZoom = () => {
    const api = getZoomApi();
    if (api) {
      zoomLoaded = true;
      return Promise.resolve(api);
    }
    if (zoomPromise) return zoomPromise;
    if (!zoomJsUrl || !zoomCssUrl) {
      return Promise.reject(new Error('Assets do zoom nao configurados.'));
    }

    zoomPromise = Promise.all([
      loadStylesheet(zoomCssUrl),
      loadScript(zoomJsUrl)
    ]).then(() => {
      const readyApi = getZoomApi();
      if (!readyApi) throw new Error('Runtime de zoom carregou sem expor a API esperada.');
      zoomLoaded = true;
      document.documentElement.dataset.dltPdpZoom = 'ready';
      return readyApi;
    }).catch((error) => {
      zoomPromise = null;
      console.error('[DLT Zoom] Falha no carregamento sob demanda.', error);
      throw error;
    });

    return zoomPromise;
  };

  const getGalleryIndexFromButton = (button, gallery) => {
    const media = button?.closest('.product-gallery__media');
    const images = Array.from(gallery?.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])') || []);
    const directIndex = media ? images.indexOf(media) : -1;
    if (directIndex >= 0) return directIndex;

    const carousel = gallery?.querySelector('media-carousel');
    const selected = carousel?.selectedSlide || gallery?.querySelector('.product-gallery__media.is-selected');
    const selectedIndex = images.indexOf(selected);
    return selectedIndex >= 0 ? selectedIndex : 0;
  };

  const nativeZoomFallback = (gallery, index = 0) => {
    if (!gallery) return;
    if (typeof gallery.openZoom === 'function') {
      gallery.openZoom(index);
      return;
    }
    gallery.dispatchEvent(new CustomEvent('lightbox:open', {
      bubbles: true,
      detail: { index }
    }));
  };

  const prewarmZoomFromEvent = (event) => {
    if (zoomLoaded || zoomPromise) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest(ZOOM_BUTTON)) return;
    loadZoom().catch(() => {});
  };

  const handleFirstZoomClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest(ZOOM_BUTTON);
    if (!button) return;

    const gallery = button.closest(ZOOM_GALLERY);
    if (!gallery) return;

    if (getZoomApi()) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const index = getGalleryIndexFromButton(button, gallery);
    loadZoom()
      .then((api) => {
        if (typeof api.openFromButton === 'function') api.openFromButton(button);
        else if (typeof api.openGallery === 'function') api.openGallery(gallery, index);
        else nativeZoomFallback(gallery, index);
      })
      .catch(() => nativeZoomFallback(gallery, index));
  };

  const handleFirstLightboxOpen = (event) => {
    if (getZoomApi()) return;
    const target = event.target instanceof Element ? event.target : null;
    const gallery = target?.closest(ZOOM_GALLERY);
    if (!gallery) return;

    event.preventDefault?.();
    event.stopImmediatePropagation();

    const requested = Number(event.detail?.index);
    const index = Number.isFinite(requested) ? requested : 0;
    loadZoom()
      .then((api) => {
        if (typeof api.openGallery === 'function') api.openGallery(gallery, index);
        else nativeZoomFallback(gallery, index);
      })
      .catch(() => nativeZoomFallback(gallery, index));
  };

  // Runtime complementar: inicia apos o caminho critico, mas antecipa na primeira intencao real.
  scheduleRuntime();
  document.addEventListener('pointerdown', prewarmRuntimeFromEvent, { capture: true, passive: true });
  document.addEventListener('focusin', prewarmRuntimeFromEvent, { capture: true });
  document.addEventListener('change', prewarmRuntimeFromEvent, { capture: true });
  document.addEventListener('shopify:section:load', () => loadRuntime().catch(() => {}));

  // Zoom: zero CSS/JS no carregamento inicial. Hover/foco/pointerdown apenas preaquece.
  document.addEventListener('pointerover', prewarmZoomFromEvent, { capture: true, passive: true });
  document.addEventListener('pointerdown', prewarmZoomFromEvent, { capture: true, passive: true });
  document.addEventListener('focusin', prewarmZoomFromEvent, { capture: true });
  document.addEventListener('click', handleFirstZoomClick, true);
  document.addEventListener('lightbox:open', handleFirstLightboxOpen, true);
})();
